import React from "react";
import styled from "styled-components";

const HeaderWrapper = styled.div`
  position: relative;
  width: 100%;
  min-height: 40vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #000;
  font-size: 2.5rem;
  font-weight: bold;
  overflow: hidden;
  text-align: center;
  padding: 20px;
  background: #fff;
`;

const Title = styled.h1`
  z-index: 10;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.18);
`;

const SubTitle = styled.p`
  font-size: 1.5rem;
  margin-top: 10px;
  color: inherit;
  max-width: 600px;
  line-height: 1.5;
  text-align: center;
`;

const DecorativeCircles = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin-top: 32px;
  gap: 12px 20px;
  width: 60%;
`;

const Circle = styled.div`
  width: 14px;
  height: 14px;
  background: radial-gradient(circle,rgb(0, 78, 89),rgb(1, 75, 91) 60%);
  border-radius: 50%;
  animation: pulse 2.5s ease-in-out infinite;
  opacity: 0.8;

  @keyframes pulse {
    0% { transform: scale(1); opacity: 0.7; }
    50% { transform: scale(1.3); opacity: 1; }
    100% { transform: scale(1); opacity: 0.7; }
  }
`;

const Header = ({ title, subtitle, height }) => {
  return (
    <HeaderWrapper style={{ minHeight: height || '40vh' }}>
      <Title>{title}</Title>
      <SubTitle>{subtitle}</SubTitle>
     
   
    </HeaderWrapper>
  );
};

export default Header;
